import styled from "styled-components";

export const SOnboardingTourCardPointerWithClick = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;
